import { post } from '~/plugins/nikan-api'
import _ from 'lodash'
import Endpoints from '@nikan/endpoints'

const Keys = {
  SET: 'set_props',
  CLEAR: 'clear_all'
}

export const state = {
  properties: []
}
export const mutations = {
  [Keys.SET](state, items) {
    state.properties = [].concat(items)
  },

  [Keys.CLEAR](state) {
    state.properties = []
  }
}
export const actions = {
  refresh({ commit }, options) {
    options = _.extend({ force: false }, options)

    return post(Endpoints.getUrl('general.getAllProperties'))
      .then(result => {
        commit(Keys.SET, result.data.items)
      })
  },
  clear({ commit }) {
    commit(Keys.CLEAR)
  }
}
export const getters = {
  all: state => {
    return state.properties
  },
  getById: state => id => {
    return _.head(state.properties.filter(x => x.id === id))
  },
  getByKey: state => key => {
    return _.head(state.properties.filter(x => x.key === key))
  },
  getByName: state => name => {
    return _.head(state.properties.filter(x => x.name === name))
  },
  getByGroup: state => groupName => {
    return state.properties.filter(x => x.group === groupName)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
